import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Stress verminderen door te sporten</title>
                <link rel="canonical" href={route("blogs.first")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Sporten gaat vaak als eerste ten koste van stress en tijdsdruk, terwijl sporten naast fysieke voordelen ook voor je mentale gezondheid bevorderend is."
                />
                <meta
                    property="og:description"
                    content="Sporten gaat vaak als eerste ten koste van stress en tijdsdruk, terwijl sporten naast fysieke voordelen ook voor je mentale gezondheid bevorderend is."
                />
                <meta property="og:url" content={route("blogs.first")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Stress verminderen door te sporten - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/stress-verminderen.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/stress-verminderen.webp"
                                    type="image/webp"
                                    alt="Stress verminderen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/stress-verminderen.jpg"
                                    type="image/jpeg"
                                    alt="Stress verminderen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/stress-verminderen.jpg"
                                    alt="Stress verminderen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Stress verminderen door te sporten
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Bijna iedereen zal weleens last hebben (gehad) van
                        stress. In onze maatschappij word prestatiedruk een
                        steeds grotere factor. Je wilt presteren op je werk of
                        studie, tijd besteden aan je gezin en/of familie en ook
                        nog eens tijd hebben om af te spreken met je vrienden.
                        Wellicht wil je hiernaast ook nog tijd besteden aan je
                        hobby. En waar haal je naast dit alles dan tijd vandaan
                        om te sporten?
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Sporten gaat vaak als eerste ten koste van stress en
                        tijdsdruk, terwijl sporten naast fysieke voordelen ook
                        voor je mentale gezondheid bevorderend is. Het
                        vermindert namelijk stress. Daarom is het van belang om
                        te blijven sporten, ook als je druk bent en juist veel
                        stress ervaart.
                    </p>
                    {/* -- */}
                    <h2 className="mt-8 text-gray-100 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Wat houdt stress in?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Stress is kortgezegd een gevoel van druk of spanning.
                        Stress word over het algemeen als ‘slecht’ gezien,
                        terwijl dit niet helemaal terecht is. Stress kan
                        namelijk ook positief zijn. Door stress komt ons lichaam
                        namelijk in staat van paraatheid, wat ervoor zorgt dat
                        we ons beter kunnen concentreren en sneller kunnen
                        reageren.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Door stress komen drie stresshormonen vrij: Adrenaline,
                        noradrenaline en cortisol. Adrenaline heeft onder andere
                        als effect dat je hartslag en bloeddruk stijgen en er
                        meer zuurstof naar je spieren, hart en hersenen gaat.
                        Noradrenaline heeft nagenoeg dezelfde effecten als
                        adrenaline. Door noradrenaline gaan de hersenen en
                        zenuwstelsel sneller werken. Dit zorgt er mede voor dat
                        je in staat van paraatheid komt in belangrijke
                        situaties. Cortisol heeft ook meerdere effecten. Zo
                        breekt dit hormoon de eiwitten in je spieren af tot
                        aminozuren, die dan weer worden omgezet tot glucose. Dit
                        kan het lichaam gebruiken als energie. Hierdoor stijgt
                        ook je bloedsuikerspiegel. Verder zorgt cortisol voor
                        het tijdelijk uitschakelen van het immuunsysteem en het
                        vertragen van je spijsvertering. Herken je zo het gevoel
                        dat je op drukke dagen minder eet maar eigenlijk geen
                        honger ervaart tijdens deze drukte?
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het langdurig aanblijven van stress heeft wel vele
                        negatieve effecten. Wanneer deze drie stresshormonen
                        langdurig worden afgegeven, kan dit zowel fysiek als
                        psychisch nadelig gevolgen hebben. Zo zorgen een
                        toegenomen hartslag en bloeddruk voor een verhoogd
                        risico op hart- en vaatziektes. Ook loop je extra
                        gezondheidsrisico’s door een slechter functionerend
                        immuunsysteem en spijsvertering. Daarnaast kan
                        langdurige stress een negatief effect hebben op je huid,
                        libido en zelfs je vruchtbaarheid.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ook mentaal gezien heeft langdurige stress een negatieve
                        werking. Door langdurige toename van je cortisolgehalte
                        worden namelijk ook je hersenen aangetast. Je
                        kortetermijngeheugen en concentratievermogen
                        verminderen. Daarnaast wordt je door de hoge
                        cortisolwaarde vatbaarder voor depressies en
                        angststoornissen.
                    </p>
                    {/* -- */}
                    <h2 className="mt-8 text-gray-100 font-bold uppercase xs:text-3xl sm:text-3xl">
                        De voordelen van sporten bij het tegengaan van stress
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Sporten is een belangrijk onderdeel bij het verminderen
                        van stress. Tijdens het sporten komen namelijk meerdere
                        gelukshormonen vrij: Dopamine, serotonine en endorfine.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dopamine zorgt voor een tevreden en voldaan gevoel.
                        Hiermee zorgt dopamine ervoor dat we extra motivatie
                        krijgen. Endorfine zorgt ook voor een geluksgevoel. Het
                        geeft je een gevoel van euforie. Daarnaast werkt het ook
                        pijn onderdrukkend. Serotonine heeft ook een invloed op
                        je humeur. Het heeft invloed op je welzijn en
                        tevredenheid. Zo zorgt serotonine voor het stimuleren
                        van je geheugen en de diepe slaap bevorderen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Naast deze gelukshormonen heeft sporten ook nog eens een
                        positief effect op je hersenen. Door genoeg te bewegen
                        worden nieuwe verbindingen gemaakt in onder andere de
                        frontale kwab, terwijl oude verbindingen gehandhaafd
                        blijven. De frontale kwab heeft een rol bij bepaalde
                        fysieke bewegingen, bij vele psychische functies zoals
                        je beoordelingsvermogen en rede en stimuleert het je
                        denkvermogen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Behalve de positieve effecten op de frontale kwab zorgt
                        sporten ook voor een verhoogde activiteit van de
                        hippocampus in de hersenen. De hippocampus heeft een
                        remmende werking op de hypothalamus, welke kan toenemen
                        door te sporten. Het remmen van de hypothalamus zorgt
                        weer voor een afname in de productie van cortisol en
                        daarmee voor het verminderen van stress.
                    </p>
                    {/* -- */}
                    <h2 className="mt-8 text-gray-100 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Blijf altijd voldoende in beweging
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Sporten heeft dus enorm veel voordelen, zowel fysiek als
                        psychisch. Juist als je stress ervaart is het voor je
                        mentale welzijn nog belangrijker om te blijven sporten.
                        Hiermee creëer je een tevreden en euforisch gevoel en ga
                        je tegelijkertijd stress en depressieve gevoelens tegen.
                        Zorg er ondanks de huidige prestatiemaatschappij dus
                        voor dat je ten alle tijden in beweging blijft!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
